module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = " <div class=\"tile-media\"> <% if( /(facebook|twitter|instagram|vine)/i.test(data.source) ){ %> <div class=\"tile-media-left\"> <figure> <img class=\"tile-media-object\" src=\"<%- data.avatar %>\" onerror=\"this.src='https://assets.votenow.tv/widgets/fan-feed/images/user.jpg'\"> </figure> </div> <% } %> <div class=\"tile-media-body\"> <% if( /(facebook|flex)/i.test(data.source) ){ %> <h4 class=\"tile-media-heading\"><strong><%- data.user_name %></strong></h4> <% } else if( /(twitter|vine)/i.test(data.source) ){ %> <h4 class=\"tile-media-heading\"><strong><%- data.user_name %></strong></h4> <h5 class=\"tile-media-heading\">@<%- data.screen_name %></h5> <% } else if ( /(instagram)/i.test(data.source) ){ %> <h4 class=\"tile-media-heading\"><strong>@<%- data.screen_name %></strong></h4> <% } %> </div> </div> "
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append(" <div class=\"tile-media\"> ")
    ;  if( /(facebook|twitter|instagram|vine)/i.test(data.source) ){ 
    ; __append(" <div class=\"tile-media-left\"> <figure> <img class=\"tile-media-object\" src=\"")
    ; __append( data.avatar )
    ; __append("\" onerror=\"this.src='https://assets.votenow.tv/widgets/fan-feed/images/user.jpg'\"> </figure> </div> ")
    ;  } 
    ; __append(" <div class=\"tile-media-body\"> ")
    ;  if( /(facebook|flex)/i.test(data.source) ){ 
    ; __append(" <h4 class=\"tile-media-heading\"><strong>")
    ; __append( data.user_name )
    ; __append("</strong></h4> ")
    ;  } else if( /(twitter|vine)/i.test(data.source) ){ 
    ; __append(" <h4 class=\"tile-media-heading\"><strong>")
    ; __append( data.user_name )
    ; __append("</strong></h4> <h5 class=\"tile-media-heading\">@")
    ; __append( data.screen_name )
    ; __append("</h5> ")
    ;  } else if ( /(instagram)/i.test(data.source) ){ 
    ; __append(" <h4 class=\"tile-media-heading\"><strong>@")
    ; __append( data.screen_name )
    ; __append("</strong></h4> ")
    ;  } 
    ; __append(" </div> </div> ")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}